import React from "react";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import {
	Typography,
	CircularProgress,
	Backdrop,
	Avatar,
	Paper,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { ref, child, get, getDatabase } from "firebase/database";
import GetAuth from "../../../../GetAuth";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	boxShadow: 24,
	p: 2,
	maxWidth: "95vw",
	width: { md: "auto", xs: "100%" },
	maxHeight: "90vh",
	overflowX: "hidden",
	overflowY: "scroll",
	borderRadius: 3,
};

const MoreLinks = ({ open, setOpen }) => {
	const dbRef = ref(getDatabase(GetAuth()?.auth));
	const [load, setLoad] = useState();
	React.useEffect(() => {
		get(child(dbRef, "josettehill"))
			.then((snapshot) => {
				setLoad(snapshot.val());
			})
			.catch((error) => {
				console.log(error);
			});
	}, [dbRef]);

	return (
		<div>
			{load ? (
				<Modal
					aria-labelledby='transition-modal-title'
					aria-describedby='transition-modal-description'
					open={open}
					closeAfterTransition
					BackdropComponent={Backdrop}
					BackdropProps={{
						timeout: 500,
					}}>
					<Fade in={open}>
						<Box sx={style} style={{ backgroundImage: `url(/bg-img.jpg)` }}>
							<CancelIcon
								onClick={() => setOpen(false)}
								className='textColor'
								sx={{
									position: "fixed",
									top: "5px",
									right: "5px",
									cursor: "pointer",
								}}
							/>
							<Typography
								className='textColor'
								sx={{
									fontWeight: 900,
									textAlign: "center",
								}}
								variant='h6'
								component='div'
								gutterBottom>
								JAH Financial Service & Real Estate
							</Typography>
							{load?.moreLinks?.fields?.map((item, index) => (
								<Paper
									onClick={() => window.open(`${item?.link}`, "_blank")}
									sx={{
										display: "flex",
										my: 1.5,
										borderRadius: 15,
										alignContent: "center",
										alignItems: "center",
										p: 0.5,
										cursor: "pointer",
										"&:hover": {
											boxShadow: 4,
										},
									}}>
									<Avatar src={load?.profile?.imageLink2} />
									<Typography className='textColor' sx={{ ml: 2 }}>
										{item?.title}
									</Typography>
								</Paper>
							))}
						</Box>
					</Fade>
				</Modal>
			) : (
				<Backdrop
					sx={{
						color: "#fff",
						zIndex: (theme) => theme.zIndex.drawer + 1,
					}}
					open={true}>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</div>
	);
};

export default MoreLinks;
